import { TelecomApiService } from "./telecom-api.service";

/**
 * Create Telecom API service instance.
 * Uses /telecom-api proxy endpoint instead of direct Telecom API URL.
 */
const getTelecomApiBaseUrl = (): string => {
  return "/telecom-api";
};

/**
 * Get or create Telecom API service instance.
 * Use this service to make requests to Telecom API from TMA.
 * 
 * This uses lazy initialization to avoid circular dependency issues.
 */
let telecomApiServiceInstance: TelecomApiService | null = null;

export const getTelecomApiService = async (): Promise<TelecomApiService> => {
  if (!telecomApiServiceInstance) {
    const { telecomTokenService } = await import("../../entities/user");
    telecomApiServiceInstance = new TelecomApiService(
      {
        baseUrl: getTelecomApiBaseUrl(),
        timeout: 60000, // 60 seconds
      },
      telecomTokenService,
    );
  }
  return telecomApiServiceInstance;
};

/**
 * Synchronous getter for Telecom API service (use only after initialization).
 * For most cases, use getTelecomApiService() instead.
 */
export const telecomApiService = new Proxy({} as TelecomApiService, {
  get(_target, prop) {
    if (!telecomApiServiceInstance) {
      throw new Error(
        "telecomApiService not initialized. Use getTelecomApiService() first or import from 'api/telecom-service'",
      );
    }
    // Use proper typing instead of any
    const value = telecomApiServiceInstance[prop as keyof TelecomApiService];
    if (typeof value === 'function') {
      return value.bind(telecomApiServiceInstance);
    }
    return value;
  },
});

// Initialize service on module load (async)
getTelecomApiService().catch((error) => {
  console.error("Failed to initialize TelecomApiService:", error);
});

